import { useEffect, useState } from "react";
import {
  isAssistantMessage,
  isUserMessage,
  type AssistantMessage,
  type Message,
  type UserMessage,
} from "../types";

// User Turn represents a unit in the chat thread
// It contains a user message and all the assistant messages that follow it
// A new user message starts a new user turn
// Can also be thought of as a Question and all the responses to that question
interface UserTurn {
  userMessage: UserMessage;
  assistantMessages: AssistantMessage[];
}

export function useUserTurnMessages(thread: Message[]) {
  const [userTurns, setUserTurns] = useState<UserTurn[]>([]);

  useEffect(
    function groupMessagesIntoUserTurns() {
      // Group messages into turns
      // Each turn is a user message and all the assistant messages that follow it
      const turns = thread.reduce((acc, message) => {
        if (isUserMessage(message)) {
          acc.push({ userMessage: message, assistantMessages: [] });
        }

        if (isAssistantMessage(message)) {
          acc[acc.length - 1]?.assistantMessages.push(message);
        }

        return acc;
      }, [] as UserTurn[]);

      setUserTurns(turns);
    },
    [thread],
  );

  return userTurns;
}
